/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchemeEmployerModel
 */
export interface SchemeEmployerModel {
    /**
     * 
     * @type {number}
     * @memberof SchemeEmployerModel
     */
    employerId?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemeEmployerModel
     */
    schemeId?: number;
    /**
     * 
     * @type {string}
     * @memberof SchemeEmployerModel
     */
    employerName?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemeEmployerModel
     */
    employerStatus?: string;
}

/**
 * Check if a given object implements the SchemeEmployerModel interface.
 */
export function instanceOfSchemeEmployerModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SchemeEmployerModelFromJSON(json: any): SchemeEmployerModel {
    return SchemeEmployerModelFromJSONTyped(json, false);
}

export function SchemeEmployerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchemeEmployerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employerId': !exists(json, 'EmployerId') ? undefined : json['EmployerId'],
        'schemeId': !exists(json, 'SchemeId') ? undefined : json['SchemeId'],
        'employerName': !exists(json, 'EmployerName') ? undefined : json['EmployerName'],
        'employerStatus': !exists(json, 'EmployerStatus') ? undefined : json['EmployerStatus'],
    };
}

export function SchemeEmployerModelToJSON(value?: SchemeEmployerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EmployerId': value.employerId,
        'SchemeId': value.schemeId,
        'EmployerName': value.employerName,
        'EmployerStatus': value.employerStatus,
    };
}

